var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M16 2.667C8.64 2.667 2.665 8.64 2.665 16s5.973 13.333 13.333 13.333S29.333 23.36 29.333 16 23.359 2.667 15.999 2.667Zm6.186 9.066c-.2 2.107-1.067 7.227-1.507 9.587-.186 1-.56 1.333-.906 1.373-.774.067-1.36-.506-2.107-1-1.173-.773-1.84-1.253-2.973-2-1.32-.866-.467-1.346.293-2.12.2-.2 3.613-3.306 3.68-3.586a.267.267 0 0 0-.067-.24c-.08-.067-.186-.04-.28-.027-.12.027-1.986 1.267-5.626 3.72-.534.36-1.014.547-1.44.533-.48-.013-1.387-.266-2.067-.493-.84-.267-1.493-.413-1.44-.88.027-.24.36-.48.987-.733 3.893-1.694 6.48-2.814 7.773-3.347 3.707-1.547 4.467-1.813 4.973-1.813.107 0 .36.026.52.16a.529.529 0 0 1 .187.36c-.013.08.013.32 0 .506Z"}));
}

Telegram.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
